<template>

  <div class="detail_root site_content" v-if="initComplete">

     <!-- 面包屑 -->
     <div class="breadcrumb_w">
        <SiteBreadcrumb />
      </div>

    <div class="top_box">
      <div class="project-title-outer">
        <span class="tradeMode-text">{{tradeModeText}}</span>
        <span class="project-title">{{itemDetail.title}}</span>
        <span v-if="itemDetail.project.transferModeName" style="color:#0983CC;margin-left:8px;font-weight:800;font-size:15px">[{{itemDetail.project.transferModeName}}]</span>
      </div>
      <div class="project_main">
        <GoodsPreview :picList="itemDetail.project.realisticImgs || []" :itemDetail="itemDetail" />
        <component :is="centerTpl(itemDetail.project.tradeMode)" :itemDetail="itemDetail" @onRefresh="getItemDetail">
        </component>
        <RightBlock :itemDetail="itemDetail"/>
      </div>
    </div>

    <RiskTip :projectRisk = "itemDetail.projectRisk"/>
    <div style="width: auto;margin-bottom: 9px;border: 1px solid #DDDFE6;" v-if="isAuction">
      <img src="@/assets/images/auction_flow.png" style="width: auto;" alt="" />
    </div>
    <div class="main_box">
      <div class="main_l w100">
        <TabContent :itemDetail="itemDetail"/>
      </div>
      <div class="main_r">
        <SideRecommend :itemDetail="itemDetail"/>
      </div>
    </div>

  </div>
</template>

<script>
import SiteBreadcrumb from '@/components/base/SiteBreadcrumb.vue'

import GoodsPreview from './GoodsPreview.vue'
import RightBlock from './RightBlock.vue'
import RiskTip from '@/views/public_0983cc/auction/detail/public/RiskTip.vue'
import TabContent from './TabContent.vue'
import SideRecommend from '@/views/public_0983cc/auction/detail/public/SideRecommend.vue'
import AuctionCenter from './AuctionCenter.vue'
import DealCenter from './DealCenter.vue'
import SmallCenter from './SmallCenter.vue'
import RenewalCenter from './RenewalCenter.vue'
import HistoryCenter from './HistoryCenter.vue'

import { auction_info,portal_auction_info2 } from '@/api/portal'
import {uuid,numTurnText } from '@/utils'
import {mapGetters} from 'vuex'
import {TradeMode,TradeModeText} from '@/enums'

export default {
  components: {
    SiteBreadcrumb,
    GoodsPreview,
    AuctionCenter,
    DealCenter,
    SmallCenter,
    RightBlock,
    RiskTip,
    TabContent,
    SideRecommend,
    RenewalCenter,
    HistoryCenter
  },
  metaInfo() {
    return {
      title:`${this.itemDetail?.title ? this.itemDetail.title+' - ':''}${this.siteInfo?.name}`,
      meta: [
        {
          name: "keywords",
          content: `${this.itemDetail?.title?this.itemDetail.title+',':''}${this.itemDetail?.project?.targets?.map((i) => i.name).join(',')?this.itemDetail?.project?.targets?.map((i) => i.name).join(','):''}`,
        },
        {
          name: "description",
          content: `${this.itemDetail?.purpose ? this.itemDetail.purpose : this.itemDetail?.describe? this.itemDetail.describe:''}`,
        },
      ],
    };
  },
  data() {
    return {
      itemDetail: null, // 项目详情数据
      initComplete: false,
    }
  },
  computed:{
    ...mapGetters(['siteInfo']),
    projectNo(){
      return this.$route.query.projectNo
    },
    centerTpl(){
      return function(tradeMode){
        switch(tradeMode){
          case TradeMode.DEAL:return 'DealCenter';
          case TradeMode.SMALL_SIMPLE:return 'SmallCenter';
          case TradeMode.AUCTION:return 'AuctionCenter';
          case TradeMode.RENEWAL:return 'RenewalCenter';
          case TradeMode.HISTORY:return 'HistoryCenter';
          default : return ''
        }
      }
    },
    isAuction() {
      return this.itemDetail.project.tradeMode === TradeMode.AUCTION
    },
    tradeModeText(){
      return TradeModeText[this.itemDetail.project.tradeMode]
    },

  },
  created() {
    this.getItemDetail()
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {

    // 获取项目详情 api
    async getItemDetail() {
      const { data } = await portal_auction_info2({
        projectNo: this.projectNo,
        uid: uuid(13)
      }) // 如果是动态变化的数据，必须设置uid，否则浏览器会缓存！

      this.itemDetail = JSON.parse(JSON.stringify(data))
      this.initComplete = true
    },
  }
}
</script>

<style lang="scss" scoped>

  .detail_root{
    margin: 0 auto 20px auto;
    padding-top: 15px;
  }
  .top_box{
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px 20px;
    background-color: #fff;
    .project-title-outer{
      margin: 10px 0;
      .tradeMode-text{
        font-size: 12px;
        background-color: #0983cc;
        color: #fff;
        padding: 4px 10px;
        margin-right: 10px;
      }
    }
    .project_main{
      display: flex;
    }
  }
  .main_box{
    display: flex;
    justify-content: space-between;
    .main_l{
      background-color: #fff;
    }
  }


</style>
